var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cool-select',{attrs:{"list":_vm.counterparties,"option-value":"id","option-text":"value","isError":_vm.isError,"isDisabled":_vm.isDisabled,"placeholder":_vm.$t('CONTENT.choose')},model:{value:(_vm.currentLessorId),callback:function ($$v) {_vm.currentLessorId=$$v},expression:"currentLessorId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }